module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-tile-1-medium-b17b8112fbce4fee80ab570de6683a91.jpg";